import { useMemo } from 'react'
import { useCalendarItem } from 'screens/Calendar/FullScreenPreview/useCalendarItem'
import { CalendarFilters } from 'screens/Calendar/types'
import { StatusTag } from 'screens/FinderV2/components/List/ListRow'

export const CalendarItemStatusTag = ({ almanacFileId, postAt }: { almanacFileId: string; postAt?: string }) => {
  const filters = useMemo<CalendarFilters>(() => ({}), [])
  const startDate = postAt ?? ''

  const { data: calendarItemResponse, isLoading: isCalendarItemLoading } = useCalendarItem(
    {
      id: almanacFileId,
      filters,
      startDate,
    },
    {
      enabled: !!almanacFileId,
    },
  )

  if (isCalendarItemLoading) return null

  return <StatusTag status={calendarItemResponse?.almanac_file?.status ?? undefined} />
}
